import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import AllProjects from './pages/AllProjects';
import Gallery from './pages/Gallery';
import ProjectDetails from './pages/projectdetails/ProjectDetails';
import projectsData from './pages/projectdetails/projectsData';


const App = () => {
  return (

    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/all_projects" element={<AllProjects />} />
        <Route path="/project-details/:slug" element={<ProjectDetails projects={projectsData} />} />
        {/* Fallback route for unmatched paths */}
        <Route path="*" element={<div>Page Not Found</div>} />


        {/* Add more routes for other pages */}
      </Routes>
    </Router>
  );
};

export default App;
